import http from './http'

export const getAll  = function() {
    return http.get('./modules/Dica/DicaRouter.php?c=getall')
}


// WEBPACK FOOTER //
// ./src/js/services/tips.js